export const PREFERRED_DATE_FORMAT = 'PREFERRED_DATE_FORMAT'
export const PREFERRED_TIME_ZONE = 'PREFERRED_TIME_ZONE'
export const UI_VERSION_STORAGE_KEY = 'tickmill_ui_version'
export const UI_MENU_POSITION_STORAGE_KEY = 'tickmill_new_ui_menu_position'
export const UI_THEME_STORAGE_KEY = 'tickmill-ui-theme'

export const UI_MENU_POSITIONS = ['left', 'right', 'top'] as const
export type UIMenuPosition = (typeof UI_MENU_POSITIONS)[number]

export const DEFAULT_UI_MENU_POSITION: UIMenuPosition = 'left'

export const isUIMenuPosition = (value: unknown): value is UIMenuPosition =>
  typeof value === 'string' && UI_MENU_POSITIONS.includes(value as UIMenuPosition)

const PERSISTENT_LOCAL_STORAGE_KEYS = [
  PREFERRED_DATE_FORMAT,
  PREFERRED_TIME_ZONE,
  UI_VERSION_STORAGE_KEY,
  UI_MENU_POSITION_STORAGE_KEY,
  UI_THEME_STORAGE_KEY,
]

export const clearLocalStorageExceptPersistentPreferences = () => {
  if (typeof window === 'undefined') return

  const persistentValues = PERSISTENT_LOCAL_STORAGE_KEYS.map((key) => ({
    key,
    value: window.localStorage.getItem(key),
  })).filter((item): item is { key: string; value: string } => item.value !== null)

  window.localStorage.clear()

  persistentValues.forEach(({ key, value }) => {
    window.localStorage.setItem(key, value)
  })
}
